export default __webpack_public_path__ + "static/media/erase.e8280a9e.png";